import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'

export interface IAloDbMesureUniteConstParam extends IAloDbBaseConstParam {
    MUT_ID:number|null     
    MUT_SYMBOL:string|null
    MUT_LIBELLE:string|null
  }

export class AloDbMesureUnite extends AloDbBase {
        
    public MUT_ID:number|null
    public MUT_SYMBOL:string|null
    public MUT_LIBELLE:string|null
    
    constructor({MUT_ID,MUT_SYMBOL,MUT_LIBELLE,...args }:IAloDbMesureUniteConstParam = {} as IAloDbMesureUniteConstParam) {
        super(args)
        this.MUT_ID = MUT_ID
        this.MUT_SYMBOL = MUT_SYMBOL
        this.MUT_LIBELLE = MUT_LIBELLE
    }

    static createAloDbMesureUniteArray(datas:any) {
        return new AloBaseArray(AloDbMesureUnite,datas)
    }

    static createAloDbMesureUniteWithDetail(data:any) {
        return new AloDbMesureUnite({...data,detailLoaded:true})
    }
}
